<!-- <div class="d-flex flex-column min-vh-100"> -->
<app-header-buscador isSearching="true"></app-header-buscador>
<!-- <div class="container" style="border: solidd red 10px"> -->

<div
  class='text-center py-5 px-5 px-sm-1'
>
  <h1 style="font-size: 3.3rem">Hola, <strong>{{ lead.fullName }}</strong></h1>
  <h2>Te comparto algunas de las coincidencias que pudimos encontrar para ti</h2>
  <h3 class="m-0">Revísalas y haznos saber cual te interesa, puedes valorar con las estrellas las que mas te gusten</h3>
</div>
<div
  class="py-1 px-lg-5"
>
  <div class="row">
    <div class="col-lg-4 col-md-6 col-12">
      <div class="form-group m-0">
        <label for="basicInput">Ordenar por</label>
        <div class="input-group input-group-merge round">
          <ng-select
            [clearable]="false"
            class="custom"
            [items]="orders"
            bindLabel="name"
            [(ngModel)]="ordView"
            (ngModelChange)="ngOnInit()"
          >
          </ng-select>
        </div>
      </div>
    </div>
  </div>
  <div class="row card-grou" *ngIf="!mapa; else mapaBlock">
    <div class="row" *ngIf="tipo == 'manual'" style="width: 100%">
      <div
        class="col-12 col-md-4 col-lg-4 col-xl-4 col-sm-12 my-2"
        *ngFor="let property_client of properties; let propertyIndex = index"
      >
        <div class="card cardBloque h-100">
          <img
            [src]="property_client.property?.principalPath"
            class="card-img-top img-fluid rounded ptn"
            style="height: 280px"
            alt="Random first slide"
            (click)="verDetalles(property_client.property.id)"
          />
          <div class="card-body">
            <p class="card-subtitle">
              <small class="text-muted"
              >{{ property_client.property.province.name }}, {{ property_client.property.state.name }}</small
              >
            </p>
            <h4 class="card-title text-truncate">{{ property_client.property.title }}</h4>
            <h4 class="card-subtitle text-primary mb-1">{{ property_client.property.price | customCurrency }}</h4>
            <div class="row">
              <div class="col-xxl-12 col-12 m-0 p-0 d-lg-flex justify-content-lg-around">
                <button
                  type="button"
                  class="btn btn-primary btn-sm-block"
                  (click)="verDetalles(property_client.property.id)"
                  rippleEffect
                >
                  <i data-feather="eye" class="mr-0 mr-sm-1"></i>Ver detalle
                </button>
                <button
                  type="button"
                  class="btn btn-outline-success btn-sm-block"
                  (click)="sendWhatsapp(property_client.property)"
                  rippleEffect
                >
                  <i data-feather="message-square" class="mr-0 mr-sm-1"></i>Enviar mensaje
                </button>
              </div>
              <div class="col-xxl-12 col-12 d-xl-flex d-lg-flex justify-content-center align-items-center mt-2">
                <app-rating [propertyIndex]="propertyIndex" [properties]="properties"></app-rating>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="tipo == 'automatico'">
      <div class="col-12 col-md-4 col-lg-4 col-xl-4 col-sm-12 my-2" *ngFor="let property of properties">
        <div class="card cardBloque h-100">
          <img
            [src]="property?.principalPath"
            class="card-img-top img-fluid rounded ptn"
            style="height: 280px"
            alt="Random first slide"
            (click)="verDetalles(property.id)"
          />
          <div class="card-body ptn">
            <p class="card-subtitle" (click)="verDetalles(property.id)">
              <small class="text-muted">{{ property.province.name }}, {{ property.state.name }}</small>
            </p>
            <h4 class="card-title text-truncate" (click)="verDetalles(property.id)">
              {{ property.title }}
            </h4>
            <div class="row" (click)="verDetalles(property.id)">
              <div class="col-xl-6 col-md-12 col-12 col-lg-6 mb-1">
                <button type="button" class="btn btn-primary btn-block" (click)="verDetalles(property.id)" rippleEffect>
                  <i data-feather="eye" class="mr-0 mr-sm-1"></i>Ver detalle
                </button>
              </div>
              <div class="col-xl-6 col-md-12 col-12 col-lg-6 d-xl-flex d-lg-flex justify-content-end mt-sm-1 mt-md-1">
                <h4 class="card-subtitle text-primary">
                  {{ property.price | customCurrency }}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="properties.length == 0">
    <div class="col-12 col-md-4 col-lg-4 col-xl-4 col-sm-12 offset-md-4 offset-lg-4 offset-xl-4 my-2">
      <div class="card text-center">
        <div class="card-body">
          <h4 class="card-title">No se encontraron coincidencias.</h4>
          <p class="card-text">
            No se encontraron inmuebles con tus preferencias de búsqueda. Por favor, intenta de nuevo con otras
            preferencias.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="!mapa">
    <div class="offset-md-7 col-md-5 offset-sm-0 col-12">
      <div class="d-flex justify-content-between float-right m-1">
        <ngb-pagination
          [collectionSize]="temp.length"
          [maxSize]="3"
          [rotate]="true"
          [(page)]="page"
          [pageSize]="pageSize"
          (pageChange)="getPageData()"
          aria-label="Cambiar página"
        >
          <ng-template ngbPaginationPrevious
          ><span [data-feather]="'chevron-left'" [size]="18" [class]="'font-weight-bolder text-primary'"></span>
          </ng-template>
          <ng-template ngbPaginationNext
          ><span [data-feather]="'chevron-right'" [size]="18" [class]="'font-weight-bolder text-primary'"></span>
          </ng-template>
        </ngb-pagination>
      </div>
    </div>
  </div>

  <ng-template #mapaBlock>
    <div class="row">
      <div class="col-md-12 mb-1" style="height: 500px">
        <div id="map" class="sticky-top" style="position: fixed"></div>
      </div>
    </div>
  </ng-template>
</div>

<ng-template #modalBasicRB let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">Búsqueda por filtros</h4>
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="1" ngbAutofocus>
    <span *ngIf="obligatorios" class="text-danger">Estos campos son obligatorios</span>
    <span *ngIf="precioMal" class="text-danger">El precio mayor debe ser más grande que el mínimo</span>
    <div class="row">
      <div class="col-xl-4 col-md-4 col-12">
        <div class="form-group">
          <label for="basicInput">Tipo de operación <small class="red">*</small></label>
          <div class="input-group input-group-merge round">
            <ng-select
              [multiple]="true"
              [closeOnSelect]="false"
              class="custom"
              [items]="operationTypes"
              bindLabel="name"
              bindValue="name"
              [(ngModel)]="parametrosBusqueda.types"
              name="operationType"
              id="operationType"
              #operationType="ngModel"
              required
            >
            </ng-select>
          </div>
          <div *ngIf="operationType.invalid && (operationType.dirty || operationType.touched)" class="alert">
            <small class="text-danger" *ngIf="operationType.errors?.['required']">
              El tipo de operación es obligatorio
            </small>
          </div>
        </div>
      </div>
      <div class="col-xl-8 col-md-8 col-12">
        <div class="form-group">
          <label for="basicInput">Tipo de propiedad <small class="red">*</small></label>
          <div class="input-group input-group-merge round">
            <ng-select
              [multiple]="true"
              [closeOnSelect]="false"
              class="custom"
              [items]="propertyTypes"
              bindLabel="name"
              bindValue="id"
              [(ngModel)]="parametrosBusqueda.propertyTypes"
              name="propertyType"
              id="propertyType"
              #propertyType="ngModel"
              required
            >
            </ng-select>
          </div>

          <div *ngIf="propertyType.invalid && (propertyType.dirty || propertyType.touched)" class="alert">
            <small class="text-danger" *ngIf="propertyType.errors?.['required']">
              El tipo de propiedad es obligatorio
            </small>
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-md-6 col-12">
        <div class="form-group">
          <label for="basicInput">Precio mínimo <small class="red">*</small></label>
          <div
            class="input-group input-group-merge round"
            [ngClass]="minPrice.invalid && (minPrice.dirty || minPrice.touched) ? 'is-invalid' : ''"
          >
            <div class="input-group-prepend">
              <span class="input-group-text round"><span [data-feather]="'dollar-sign'"></span></span>
            </div>
            <input
              maxlength="13"
              oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
              (ngModelChange)="onQtrInputChange($event, 1)"
              (focus)="onFocusCommaInput(1)"
              (blur)="onBlurCommaInput()"
              [ngModel]="parametrosBusqueda.range.lowerText | currencyCommasHundredsLanding"
              type="text"
              class="form-control round"
              required
              [ngClass]="minPrice.invalid && (minPrice.dirty || minPrice.touched) ? 'is-invalid' : ''"
              name="minPrice"
              id="minPrice"
              #minPrice="ngModel"
            />
          </div>
          <div *ngIf="minPrice.invalid && (minPrice.dirty || minPrice.touched)" class="alert">
            <small class="text-danger" *ngIf="minPrice.errors?.['required']"> El precio mínimo es obligatorio </small>
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-md-6 col-12">
        <div class="form-group">
          <label for="basicInput">Precio máximo <small class="red">*</small></label>
          <div
            class="input-group input-group-merge round"
            [ngClass]="maxPrie.invalid && (maxPrie.dirty || maxPrie.touched) ? 'is-invalid' : ''"
          >
            <div class="input-group-prepend">
              <span class="input-group-text round"><span [data-feather]="'dollar-sign'"></span></span>
            </div>
            <input
              maxlength="13"
              oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
              (ngModelChange)="onQtrInputChange($event, 2)"
              (focus)="onFocusCommaInput(2)"
              (blur)="onBlurCommaInput()"
              [ngModel]="parametrosBusqueda.range.upperText | currencyCommasHundredsLanding"
              type="text"
              class="form-control round"
              required
              [ngClass]="maxPrie.invalid && (maxPrie.dirty || maxPrie.touched) ? 'is-invalid' : ''"
              name="maxPrie"
              id="maxPrie"
              #maxPrie="ngModel"
            />
          </div>

          <div *ngIf="maxPrie.invalid && (maxPrie.dirty || maxPrie.touched)" class="alert">
            <small class="text-danger" *ngIf="maxPrie.errors?.['required']"> El precio máximo es obligatorio </small>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form-group">
          <label for="basicInput">Colonia</label>
          <i style="font-size: 12px"> (Si deseas hacer una búsqueda general deja vacío el campo)</i>
          <div class="input-group input-group-merge round">
            <ng-select
              [multiple]="true"
              [closeOnSelect]="false"
              class="custom"
              [items]="suburbsBasic"
              bindLabel="fullName"
              bindValue="id"
              [loading]="provincesLoading"
              [(ngModel)]="parametrosBusqueda.suburbs"
            >
            </ng-select>
          </div>
        </div>
      </div>
    </div>
    <h4>
      Búsqueda avanzada
      <button
        type="button"
        class="btn btn-icon rounded-circle"
        [style]="'background-color:transparent;color:' + config?.primaryColor + ';'"
        rippleEffect
        (click)="mostrarBusquedaAvanzada()"
      >
        <i
          class="feather text-primary"
          [ngClass]="{
            'icon-chevron-down': !showBusquedaAvanzada,
            'icon-chevron-up': showBusquedaAvanzada
          }"
        ></i>
      </button>
    </h4>

    <div *ngIf="showBusquedaAvanzada">
      <div class="row">
        <div class="col-xl-3 col-md-3 col-6">
          <div class="form-group">
            <label for="basicInput">Recámaras</label>
            <div class="input-group input-group-merge round">
              <ng-select
                class="custom"
                [items]="bedrooms"
                bindLabel="name"
                bindValue="value"
                [(ngModel)]="parametrosBusqueda.amenities[0].cant"
              >
              </ng-select>
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-md-3 col-6">
          <div class="form-group">
            <label for="basicInput">Baños</label>
            <div class="input-group input-group-merge round">
              <ng-select
                class="custom"
                [items]="bathrooms"
                bindLabel="name"
                bindValue="value"
                [(ngModel)]="parametrosBusqueda.amenities[1].cant"
              >
              </ng-select>
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-md-3 col-6">
          <div class="form-group">
            <label for="basicInput">Cochera</label>
            <div class="input-group input-group-merge round">
              <ng-select
                class="custom"
                [items]="garageOpt"
                bindLabel="name"
                bindValue="value"
                [(ngModel)]="parametrosBusqueda.amenities[2].cant"
              >
              </ng-select>
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-md-3 col-6">
          <div class="form-group">
            <label for="basicInput">Niveles</label>
            <div class="input-group input-group-merge round">
              <ng-select
                class="custom"
                [items]="nivelesOpt"
                bindLabel="name"
                bindValue="value"
                [(ngModel)]="parametrosBusqueda.amenities[5].cant"
              >
              </ng-select>
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-md-3 col-6">
          <div class="form-group">
            <label for="basicInput">Mts<sup>2</sup> de terreno</label>
            <div class="input-group input-group-merge round">
              <div class="input-group-prepend">
                <span class="input-group-text round">
                  <img src="assets/icon/IconGray/area.png" height="16" width="16" />
                </span>
              </div>
              <input
                type="text"
                oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\.*)\./g, '$1');"
                class="form-control round"
                [(ngModel)]="parametrosBusqueda.amenities[3].cant"
              />
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-md-3 col-6">
          <div class="form-group">
            <label for="basicInput">Mts<sup>2</sup> de construcción</label>
            <div class="input-group input-group-merge round">
              <div class="input-group-prepend">
                <span class="input-group-text round"
                  ><img src="assets/icon/IconGray/area.png" height="16" width="16"
                /></span>
              </div>
              <input
                oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\.*)\./g, '$1');"
                type="text"
                class="form-control round"
                [(ngModel)]="parametrosBusqueda.amenities[4].cant"
              />
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-md-3 col-6">
          <div class="form-group">
            <label for="basicInput">Jardín</label>
            <div class="input-group input-group-merge round">
              <ng-select
                class="custom"
                [items]="gardenOpt"
                bindLabel="name"
                bindValue="value"
                [(ngModel)]="parametrosBusqueda.amenities[6].cant"
              >
              </ng-select>
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-md-3 col-6">
          <div class="form-group">
            <label for="basicInput">Terraza</label>
            <div class="input-group input-group-merge round">
              <ng-select
                class="custom"
                [items]="terrazaOpt"
                bindLabel="name"
                bindValue="value"
                [(ngModel)]="parametrosBusqueda.amenities[7].cant"
              >
              </ng-select>
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-md-3 col-6">
          <div class="form-group">
            <label for="basicInput">Amueblado / Renta</label>
            <div class="input-group input-group-merge round">
              <ng-select
                class="custom"
                [items]="amuebladoRentaOpt"
                bindLabel="name"
                bindValue="value"
                [(ngModel)]="parametrosBusqueda.amenities[8].cant"
              >
              </ng-select>
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-md-3 col-6">
          <div class="form-group">
            <label for="basicInput">Años de antigüedad</label>
            <div class="input-group input-group-merge round">
              <ng-select class="custom" [items]="yearsAnt" bindLabel="name" bindValue="value" [(ngModel)]="years.cant">
              </ng-select>
            </div>
          </div>
        </div>
      </div>
      <div class="row amenities-style">
        <div class="col-xl-4 col-md-6 col-sm-6 custom-control custom-checkbox" *ngFor="let am of amenities_ops">
          <div class="form-group">
            <img [src]="'assets/icon/IconGray/' + am.icon" height="20" width="20" />&nbsp;
            <input type="checkbox" class="custom-control-input" [id]="am.id" [(ngModel)]="am.switch" />
            <label class="custom-control-label text-break text-truncate" [for]="am.id" [innerHTML]="am.name"> </label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="mr-auto">
      {{ province.name }}, {{ state.name }}
      <div
        class="bold curs"
        [style]="'color:' + config?.primaryColor + ' !important;'"
        (click)="abreModal2(modalUbicationRB)"
      >
        Cambiar localización
      </div>
    </div>
    <button
      type="button"
      class="btn round"
      [style]="
        'border-color:' +
        config?.primaryColor +
        ' !important;background-color:' +
        config?.primaryColor +
        ' !important;color:' +
        config.secondaryColor +
        ' !important;'
      "
      (click)="busqueda()"
      rippleEffect
    >
      Buscar
    </button>
  </div>
</ng-template>

<ng-template #modalUbicationRB let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="myModalLabel2">Cambiar ubicación</h4>
  </div>

  <div class="modal-body" tabindex="0" ngbAutofocus>
    <div class="row">
      <div class="col-xl-4 col-md-4 col-12">
        <div class="form-group">
          <label for="basicInput">Estado</label>
          <div class="input-group input-group-merge round">
            <ng-select
              class="custom"
              [items]="statesBasic"
              bindLabel="name"
              bindValue="id"
              [loading]="stateLoading"
              [(ngModel)]="state.id"
              (change)="getProvinces($event)"
            >
            </ng-select>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-md-4 col-12">
        <div class="form-group">
          <label for="basicInput">Ciudad</label>
          <div class="input-group input-group-merge round">
            <ng-select
              class="custom"
              [items]="provincesBasic"
              bindLabel="name"
              bindValue="id"
              [loading]="provincesLoading"
              [(ngModel)]="province.id"
              (change)="getSuburbs($event)"
            >
            </ng-select>
          </div>
        </div>
      </div>
    </div>
    <i style="color: red" *ngIf="!bandProvince"> Favor de llenar los dos campos </i>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn round"
      [style]="
        'border-color:' +
        config?.primaryColor +
        ' !important;background-color:' +
        config?.primaryColor +
        ' !important;color:' +
        config.secondaryColor +
        ' !important;'
      "
      (click)="checkSelect()"
      rippleEffect
    >
      Guardar
    </button>
  </div>
</ng-template>
